<template>
  <div>
    <div class="card">
      <div class="card-content">
        <h4 class="card-title">No de Declaraciones</h4>
        <div class="row">
          <div class="col-md-6">
            <label>Declaración </label><br>
            <el-select clearable class="select-default" filterable name="declaracion" placeholder="Declaracion" v-model="model.tipo_declaracion">
              <el-option v-for="option in tiposDeclaracion" class="select-default" :value="option.id" :label="option.tipo_declaracion" :key="option.tipo_declaracion">
              </el-option>
            </el-select>
          </div>
          <div v-if="rol!=4" class="col-md-6">
            <label>Dependencia </label><br>
            <el-select clearable class="select-default" filterable name="dependencia" placeholder="Dependencia" v-model="model.dependencia_id">
              <el-option v-for="option in dependencias" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
          </div>
          <div class="col-md-6">
            <label>Desde</label><br>
            <el-date-picker name="fecha_inicio" v-model="model.fecha_inicio" format="dd-MM-yyyy" value-format="yyyy-MM-dd" type="date" placeholder="Elige un día">
            </el-date-picker>
          </div>
          <div class="col-md-6">
            <label>Hasta</label><br>
            <el-date-picker name="fecha_fin" v-model="model.fecha_fin" format="dd-MM-yyyy" value-format="yyyy-MM-dd" type="date" placeholder="Elige un día">
            </el-date-picker>
          </div>
        </div>
        <br>
        <button @click="getDeclaracionesPorFecha" class="btn btn-fill btn-success pull-right">
          Buscar
        </button>
        <br><br><br>

        <div>
          <br>
          <div class="offset-md-6 col-sm-6 col-md-6 col-lg-6">
            <b-form-group label-cols-sm="3" class="mb-0">
              <b-input-group>
                <b-form-input type="search" v-model="filter" placeholder="Buscar"></b-form-input>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="row mt-3 mb-4">
            <div class="col-sm-12 col-md-12 col-lg-12">
              <!-- <v-text-field class="col-4 offset-8" v-model="search" append-icon="fa-search" placeholder="Buscar" single-line hide-details>
            </v-text-field> -->
              <v-data-table :headers="headers" :items="filtro_usuarios" :items-per-page="5" :search="filter" class="" :fixed-header="true">
                <template v-slot:item.acciones="{ item }">
                  <div class="d-flex justify-content-center">
                    <!--
                     <b-button :id="'d'+row.item.id" variant="success" size="sm" @click.prevent="descargar(row.item)" class="edit mr-2">
                      <i class="ti-download"></i>
                    </b-button>

                    <b-button :id="'r'+row.item.id" variant="danger" size="sm" @click.prevent="reactivar(row.item)" class="edit mr-2">
                      <i class="ti-unlock"></i>
                    </b-button>
                    <b-tooltip :target="'r'+row.item.id" title="Reactivar declaración"></b-tooltip> -->
                    <b-button @click.prevent="descargar(item)" class="btn-s edit mr-2" variant="success" v-b-popover.hover.top="'Descargar Declaración'">
                      <i class="ti-download"></i></b-button>

                    <!-- <b-button @click.prevent="reactivar(item)" class="btn-s delete" variant="danger" v-b-popover.hover.top="'Reactivar declaración'">
                      <i class="ti-unlock"></i></b-button> -->
                  </div>
                </template>
                <template v-slot:item.titular_id="{ item }">
                  <div>{{filterCatalog(item.titular_id,titular_adeudo)}}</div>
                </template>

              </v-data-table>

              <!-- <b-table id="tbl_movimientos" responsive hover :items="filtro_usuarios" :fields="fields_list" :per-page="perPage" :current-page="currentPage" show-empty :filter="filter" @filtered="onFiltered">

                <template slot="acciones" slot-scope="row" class="actions">
                  <b-button :id="'d'+row.item.id" variant="success" size="sm" @click.prevent="descargar(row.item)" class="edit mr-2">
                    <i class="ti-download"></i>
                  </b-button>
                  <b-tooltip :target="'d'+row.item.id" title="Descargar Declaración"></b-tooltip>
                  <b-button :id="'r'+row.item.id" variant="danger" size="sm" @click.prevent="reactivar(row.item)" class="edit mr-2">
                    <i class="ti-unlock"></i>
                  </b-button>
                  <b-tooltip :target="'r'+row.item.id" title="Reactivar declaración"></b-tooltip>
                </template>
                <template slot="empty">
                  <h5>No existen registros</h5>
                </template>
                <template slot="id" slot-scope="row" v-show="false">{{row.item.id}}</template>
                <template slot="rfc" slot-scope="row">{{row.item.rfc}}</template>
                <template slot="nombres" slot-scope="row">{{row.item.nombres}}</template>
              </b-table> -->
            </div>

            <!-- <div class="col-mb-8 col-8">
              <b-col md="6" class="my-1">
                <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" first-text="<<" prev-text="<" next-text=">" last-text=">>" aria-controls="tbl_movimientos"></b-pagination>
              </b-col>
            </div>
            <div class="col-mb-12 col-12">
              <p class="category">Mostrando <b>{{from + 1}}</b> a <b>{{to}}</b> de <b>{{total}}</b> registros</p>
            </div> -->
          </div>
        </div>


      </div>
    </div>

  </div>
</template>
<script>
  import Vue from 'vue'
  import {
    Table,
    TableColumn,
    Select,
    Option,
    DatePicker
  } from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'

  /*   Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Select)
    Vue.use(Option)
   */

  export default {
    components: {
      PPagination,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Select.name]: Select,
      [Option.name]: Option,
      [DatePicker.name]: DatePicker,
    },
    /**
     * Chart data used to render stats, charts. Should be replaced with server data
     */
    data() {
      return {
        model: {
          tipo_declaracion: '',
          dependencia_id: '',
          periodo: ''
        },
        dependencias: {},
        rol: '',
        filter: null,
        currentPage: 1,
        perPage: 50,
        periodos: [],
        rows: null,
        tiposDeclaracion: [],
        list_cumplimiento: [],

        filtro_usuarios: [],
        pagination: {
          perPage: 5,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        searchQuery: '',
        headers: [{
            text: 'Acciones',
            align: 'center',
            sortable: false,
            value: 'acciones',
            class: ''
          }, {
            text: 'Id',
            value: 'id',
            align: 'center',
          }, {
            text: 'Tipo de Declaración',
            value: 'tipoDec',
            align: 'center'
          },
          {
            text: 'RFC',
            value: 'rfc',
            align: 'center',
          }, {
            text: 'Nombre',
            value: 'nombres',
            align: 'center',
          }, {
            text: 'Dependencia',
            value: 'entidad',
            align: 'center',
          }, {
            text: 'Correo Laboral',
            value: 'correo',
            align: 'center',
          },
        ],
        /* fields_list: [{
            key: "acciones",
            label: "Acciones",
            thClass: "td-small",
            tdClass: "text-center td-small"
          },
          {
            key: "id",
            label: "Id",
            thClass: 'd-none',
            tdClass: 'd-none'
          }, {
            key: "rfc",
            label: "RFC",
            thClass: "td-small",
            tdClass: "text-center td-small"
          }, {
            key: "nombres",
            label: "Nombres",
            thClass: "td-small",
            tdClass: "text-left td-small"
          },
          {
            key: "entidad",
            label: "Dependencia",
            thClass: "td-small",
            tdClass: "text-left td-small"
          }, {
            key: "correo",
            label: "Correo Laboral",
            thClass: "td-small",
            tdClass: "text-left td-small"
          }
        ], */
        propsToSearch: ['rfc', 'nombres'],
        tableColumns: [{
            prop: 'id',
            label: 'Dec',
            minWidth: 150,
            vif: false
          },
          {
            prop: 'rfc',
            label: 'RFC',
            minWidth: 150,
            vif: true
          },
          {
            prop: 'nombres',
            label: 'Nombre',
            minWidth: 100,
            vif: true
          }
        ]
      }
    },
    computed: {
      pagedData() {
        return this.list_cumplimiento.slice(this.from, this.to)
      },
      queriedData() {
        if (!this.searchQuery) {
          this.pagination.total = this.list_cumplimiento.length
          return this.pagedData
        }
        let result = this.list_cumplimiento
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch) {
              let rowValue = row[key].toString()
              if (rowValue.includes && rowValue.includes(this.searchQuery)) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination.total = result.length
        return result.slice(this.from, this.to)
      },
      to() {
        let highBound = this.from + this.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
      from() {
        return this.perPage * (this.currentPage - 1);
      },
      total() {
        //console.log(this.list_cumplimiento.length);
        this.rows = this.list_cumplimiento.length;

        return this.list_cumplimiento.length;
      }
    },
    watch: {
      '$route': 'checkPermissions'
    },
    methods: {

      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.rows = filteredItems.length
        this.currentPage = 1
      },
      checkPermissions() {
        let permiso = [1];
        if (!this.getKey('permisos').some(r => permiso.includes(r))) {
          localStorage.clear();
          this.$router.push('/login');
          this.$router.go();

        }
      },
      getDependencias() {
        var v = this;
        this.$http.get("cat_ente_publico").then(
          response => {
            this.dependencias = response.data.entes_publicos;
            this.dependencias.unshift({
              'codigo': 'T',
              'id': 0,
              'valor': 'Todas'
            });
          },
          error => {
            this.StepError(error);
          }
        );
      },
      getTipoDeclaracion() {
        var v = this;
        this.$http.get("tiposDeclaracion").then(
          response => {
            this.tiposDeclaracion = response.data.tipoDeclaracion;
          },
          error => {
            this.StepError(error);
          }
        );
      },
      getPeriodos() {
        var v = this;
        this.$http.get("getPeriodos").then(
          response => {
            this.periodos = response.data.periodos;
          },
          error => {
            this.StepError(error);
          }
        );
      },
      dateFormat(date) {
        return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
      },
      getDeclaracionesPorFecha() {
        this.$http.post("rdeclaraciones", this.model).then(
          response => {
            this.list_cumplimiento = [];
            response.data.declarantes.forEach((value, key) => {
              this.list_cumplimiento.push({
                'id': value.decid,
                'rfc': value.rfc,
                'nombres': value.nombres + ' ' + value.primer_apellido + ' ' + value.segundo_apellido,
                'entidad': value.ente,
                'correo': value.correo,
                'tipoDec': value.tipoDec
              });
              console.log(this.list_cumplimiento);
            });
            this.filtro_usuarios = this.list_cumplimiento;
          },
          error => {
            this.StepError(error);
          }
        );
        /* } */


      },
      /* getDeclaraciones() {

        if (this.rol == 4)
          this.model.dependencia_id = this.getKey('ente_publico_id')

        if (this.model.dependencia_id == '') {
          this.StepW("Debes seleccionar una dependencia");
        } else if (this.model.tipo_declaracion == '') {
          this.StepW("Debes seleccionar un tipo de declaración");
        } else if (this.model.periodo == '') {
          this.StepW("Debes seleccionar un periodo");
        } else {
          this.$http.get("ldeclaraciones/" + this.model.tipo_declaracion + '/' + this.model.dependencia_id + '/' + this.model.periodo).then(
            response => {
              var v = this;
              v.list_cumplimiento = [];

              //console.log(response.data.declarantes)
              $.each(response.data.declarantes, function (key, value) {
                v.list_cumplimiento.push({
                  'id': value.decid,
                  'rfc': value.rfc,
                  'nombres': value.nombres + ' ' + value.primer_apellido + ' ' + value.segundo_apellido,
                  'entidad': value.ente,
                  'correo': value.correo
                });

              });

              this.filtro_usuarios = this.list_cumplimiento;

            },
            error => {
              this.StepError(error);
            }
          );
        }


      }, */
      descargar(row) {
        //console.log(row)
        var url = [this.$http.options.root + 'getDeclaracion1/pdf/' + row.id + '/' + this.getKey('uid')];
        window.open(url, '_blank');
      },

    },
    created() {
      this.getDependencias();
      this.getTipoDeclaracion();
      this.getPeriodos();
      this.rol = this.getKey('role');
      this.checkPermissions()
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reportes/ListDeclaraciones2.vue